// src/features/dashboard/components/Header.js
import React from 'react';
import { Menu, Bell, User, LogOut, Settings, ChevronDown } from 'lucide-react';
import { useAuth } from '../../features/auth/hooks/useAuth';
import NotificationBell from './NotificationBell';

const Header = ({ sidebarOpen, setSidebarOpen }) => {
  const { user, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = React.useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-30">
      <div className="flex items-center justify-between h-16 px-4">
        <div className="flex items-center">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none"
          >
            <Menu size={24} />
          </button>
          
          <div className="ml-4">
            {/* <h1 className="text-xl font-semibold text-gray-800">
              Avyukt-OHCMS
            </h1> */}
               <img 
  src="/avyukt-healthcare-logo.png" 
  alt="Logo" 
  className="mx-auto h-10 w-auto mb-4"
/>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          {/* Notifications */}
          {/* <button className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 relative">
            <NotificationBell
  notifications={[
    {
      id: 1,
      title: "Low Stock",
      message: "Paracetamol stock is running low",
      time: "2 min ago",
      read: false,
    },
    {
      id: 2,
      title: "New Patient Registered",
      message: "John Doe added to system",
      time: "10 min ago",
      read: true,
    },
     {
      id: 2,
      title: "New Patient Registered",
      message: "John Doe added to system",
      time: "10 min ago",
      read: true,
    },
     {
      id: 2,
      title: "New Patient Registered",
      message: "John Doe added to system",
      time: "10 min ago",
      read: true,
    },
     {
      id: 2,
      title: "New Patient Registered",
      message: "John Doe added to system",
      time: "10 min ago",
      read: true,
    },
     {
      id: 1,
      title: "Low Stock",
      message: "Paracetamol stock is running low",
      time: "2 min ago",
      read: false,
    },
    {
      id: 2,
      title: "New Patient Registered",
      message: "John Doe added to system",
      time: "10 min ago",
      read: true,
    },
     {
      id: 2,
      title: "New Patient Registered",
      message: "John Doe added to system",
      time: "10 min ago",
      read: true,
    },
     {
      id: 2,
      title: "New Patient Registered",
      message: "John Doe added to system",
      time: "10 min ago",
      read: true,
    },
     {
      id: 2,
      title: "New Patient Registered",
      message: "John Doe added to system",
      time: "10 min ago",
      read: true,
    },
     {
      id: 1,
      title: "Low Stock",
      message: "Paracetamol stock is running low",
      time: "2 min ago",
      read: false,
    },
    {
      id: 2,
      title: "New Patient Registered",
      message: "John Doe added to system",
      time: "10 min ago",
      read: true,
    },
     {
      id: 2,
      title: "New Patient Registered",
      message: "John Doe added to system",
      time: "10 min ago",
      read: true,
    },
     {
      id: 2,
      title: "New Patient Registered",
      message: "John Doe added to system",
      time: "10 min ago",
      read: true,
    },
     {
      id: 2,
      title: "New Patient Registered",
      message: "John Doe added to system",
      time: "10 min ago",
      read: true,
    },
  ]}
/>
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
          </button> */}

          {/* User Menu */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center space-x-3 p-2 rounded-md hover:bg-gray-100 focus:outline-none"
            >
              <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                <User size={16} className="text-white" />
              </div>
              <div className="hidden md:block text-left">
                <p className="text-sm font-medium text-gray-700">{user?.name}</p>
                <p className="text-xs text-gray-500">{user?.role}</p>
              </div>
              <ChevronDown size={16} className="text-gray-600" />
            </button>

            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
                <a
                  href="/profile"
                  className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <User size={16} className="mr-3" />
                  Profile
                </a>
                <a
                  href="/settings"
                  className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <Settings size={16} className="mr-3" />
                  Settings
                </a>
                <hr className="my-1" />
                <button
                  onClick={logout}
                  className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                >
                  <LogOut size={16} className="mr-3" />
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;